import React, { FC } from 'react'
import cx from 'classnames'
import { useParams } from 'react-router-dom'
import { PopupMenu } from 'components/PopupMenu'
import { Area } from 'models/project'
import { useTranslation } from 'react-i18next'
import { Button } from 'components/Button'
import { Icon } from 'components/Icon'
import { getAreaIcon } from 'utils/areaDetails'
import { Text } from 'components/Text'
import { ButtonLink } from 'components/ButtonLink'
import { Badge } from 'components/Badge'
import { Flex } from 'components/Flex'
import styles from './CompareMenu.module.scss'
import { useMapEditorUpdater, MapEditorWizards } from 'context/map-editor-context'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { fetchAreas, takeArea } from 'actions/project'

type CompareMenuProps = {
  handleDeleteArea: any
  areas?: Area[]
}

export const CompareMenu: FC<CompareMenuProps> = ({ handleDeleteArea }) => {
  const { t } = useTranslation()
  const mapEditorDispatch = useMapEditorUpdater()
  const { projectId, areaId } = useParams()
  const dispatch = useDispatch()

  React.useEffect(() => {
    dispatch(fetchAreas(projectId))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const areas = useSelector((state: RootStateOrAny) => state.areas.areas)

  const OnDeleteClick = (e: any) => {
    dispatch(takeArea(e.target.value))

    // handleDeleteArea() // Leave it be. I don't remember what was this for.
  }

  return (
    <div className={styles.compareMenu}>
      <PopupMenu
        label={t('panel.compare.title')}
        className={styles.compareMenuList}
        trigger={
          <Badge tone="outline">
            <Flex align="center">
              <Text
                size="small"
                weight="strong"
                className={styles.compareTriggerText}
                component="span"
              >
                {t('panel.compare.title')}
              </Text>{' '}
              <Icon name="arrow-down-s-line" className={styles.compareTriggerIcon} />
            </Flex>
          </Badge>
        }
        triggerOffset={10}
      >
        {[
          <Button
            key="area-new"
            onClick={() => mapEditorDispatch.setWizard(MapEditorWizards.COMPARE_AREA)}
            full
            className={styles.compareMenuItem}
            variant="outline"
          >
            <Text component="span" weight="strong">
              {t('panel.compare.new_area')}
            </Text>{' '}
            <Icon name="add-fill" size="xl" />
          </Button>,
          ...areas.map((area: Area) => (
            <div className={styles.compareAreaSection} key={`area-${area.id}`}>
              <ButtonLink
                key={`area-${area.id}`}
                to={`/projects/${projectId}/compare/${area.id}`}
                className={cx(
                  styles.compareMenuItem,
                  parseInt(areaId) === area.id ? styles.active : null,
                )}
                style={{ backgroundColor: area.color }}
                full
              >
                <Text component="span" truncate>
                  {area.name}
                </Text>
                <Icon name={getAreaIcon(area.areaType)} size="xl" />
              </ButtonLink>
              <button
                className={styles.compareAreaDeleteButton}
                value={area.id}
                onClick={OnDeleteClick}
              ></button>
            </div>
          )),
        ]}
      </PopupMenu>
    </div>
  )
}

CompareMenu.displayName = 'CompareMenu'
